import React, {Component} from 'react'
import {Button, Form, Row, Col, Input, Table, Modal} from 'antd'
import {toJS} from 'mobx'
import {DeleteOutlined, QuestionCircleFilled, EditOutlined, SearchOutlined, PlusOutlined} from '@ant-design/icons'
import forumlaTypeAPI from '../../apis/forumlaType'
import {getPaginationConfig} from '../../components/pagination'
import AddFormModal from './AddFormModal'
import EditFormModal from './EditFormModal'
import UPM from '../../constants/urlPermissionMappings'
import {withTranslation} from 'react-i18next'

const {confirm} = Modal

class forumlaType extends Component {
  state = {
    page: 1, // 当前页
    size: 10, // 每页显示条数
    total: null, // 总条数
    addModalVisible: false,
    editModalVisible: false,
    id: null,
    tableData: []
  }
  formRef = React.createRef()

  componentDidMount() {
    this.handleSearch(1, 10)
  }

  handleSearch = (page, size) => {
    this.formRef.current.validateFields().then(fieldsValue => {
      let params = {
        name: fieldsValue.name,
        page: page ? page : this.state.page,
        size: size ? size : this.state.size,
      }
      forumlaTypeAPI.searchAction(params).then(res => {
        this.setState({
          tableData: res.data.data?.records,
          page: res.data.data.current, // 当前页
          size: res.data.data.size, // 每页显示条数
          total: res.data.data.total // 总条数
        })
      })
    }).catch(err => {
    })
  }

  handleCreate = () => {
    this.setState({
      addModalVisible: true
    })
  }

  handleCancel = (target) => {
    this.setState({
      [target]: false
    })
  }

  handlePageChange = (page, pageSize) => {
    // page 目标页
    // pageSize 显示条数
    this.handleSearch(page, pageSize)
  }

  handleEdit = (id) => {
    this.setState({
      editModalVisible: true,
      id
    })
  }

  handleDel = (record) => {
    const {t} = this.props
    let _this = this
    confirm({
      title: t(`general.deleteData`),
      icon: <QuestionCircleFilled/>,
      content: t(`general.sureToDelete`),
      okText: t(`general.delete`),
      cancelText: t(`general.cancel`),
      onOk() {
        forumlaTypeAPI.delAction(record.id).then(res => {
          _this.handleSearch()
        })
      },
      onCancel() {
        console.log('Cancel')
      },
    })
    return false
  }

  getRowClassName = (record, index) => {
    let className = ''
    className = index % 2 === 0 ? 'oddRow' : 'evenRow'
    return className
  }
  render() {
    const {location, t} = this.props
    const pagination = getPaginationConfig(this.state.page, this.state.size, this.state.total, this.handlePageChange)

    return (
      <div className="container">
        <Form ref={this.formRef} size="middle" className="searchForm" layout="vertical">
          <div className="searchFormTitle">
            <SearchOutlined/> {t(`menu.${UPM.find(item => item.url === location?.pathname)?.pKey}`)}
          </div>
          <Row gutter={[10, 0]}>
            <Col span={4}>
              <Form.Item name="name" label={t(`formulaType.name`)}>
                <Input placeholder={t(`general.pleaseEnter`)} allowClear/>
              </Form.Item>
            </Col>

            <Col span={12} offset={8} style={{textAlign: 'right', marginTop: 30}}>
              <Button onClick={() => { this.handleSearch(1, 10) }} type='danger'>{t(`general.search`)}</Button>
              <Button onClick={this.handleCreate} type="primary" icon={<PlusOutlined/>}>{t(`general.add`)}</Button>
            </Col>
          </Row>
        </Form>

        <Table className="searchResult" dataSource={toJS(this.state.tableData)} rowKey="id" pagination={pagination} rowClassName={this.getRowClassName}>
          <Table.Column title={t(`formulaType.name`)} dataIndex="name" key="name" ellipsis={true}/>
          <Table.Column title={t(`formulaType.creator`)} dataIndex="createUser" key="createUser" ellipsis={true}/>
          <Table.Column title={t(`formulaType.createTime`)} dataIndex="createTime" key="createTime" ellipsis={true}/>
          <Table.Column align="center" title={t(`general.action`)} key="Action" render={(text, record) => (
            <>
              <Button type="link" onClick={() => this.handleEdit(record.id)} icon={<EditOutlined/>} title={t(`general.edit`)}/>
              <Button type="link" onClick={() => this.handleDel(record)} icon={<DeleteOutlined/>} title={t(`general.delete`)}/>
            </>
          )}/>
        </Table>
        {this.state.addModalVisible ?
          <AddFormModal handleCancel={this.handleCancel} handleSearch={this.handleSearch} addModalVisible={this.state.addModalVisible}/> : null}
        {this.state.editModalVisible ? <EditFormModal handleCancel={this.handleCancel} id={this.state.id} handleSearch={this.handleSearch}
                                                      editModalVisible={this.state.editModalVisible}/> : null}
      </div>
    )
  }
}

export default withTranslation()(forumlaType)
